import { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';

import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import loading from "../../../assets/images/loading.gif"
import { makeGetRequest, makePatchRequest } from "../../../request";
import { useDispatch, useSelector } from "react-redux";
import { customStyles, formatDateTime } from "../../../helpers";
import Pagination from "../../../components/Pagination";
import Layout from "../../Layout";
import { setPageContext } from "../../../store/pageContext";
import Modal from 'react-modal'

const AssignedShippingDocuments =  () => {
    const params = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [shippingDocuments, setShippingDocuments] = useState<Record <string, any>>()
    const [reassignLocalClearingAgentModal, setReassignLocalClearingAgentModal] = useState(false)
    const user:any = useSelector((state: any) => state.tepngUser.value);
    
    const [formData, setFormData] = useState<Record <string, any>>({
        localClearingAgentId: "",
        transitManagerId: "",
        shippingDocumentId: "",
        reasonForReassignment: "",
        // rowVersion: ""
    })

    const clearFormData = () => {
        setFormData({...formData, localClearingAgentId: "", transitManagerId: "", shippingDocumentId: "", reasonForReassignment: "", rowVersion: ""})
    }

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const [startIndex, setStartIndex] = useState(0);
    const getPageNumbers = () => {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            if (currentPage >= startIndex + 4) {
                setStartIndex(startIndex + 4);
            }
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            if (currentPage - 1 <= startIndex) {
                setStartIndex(startIndex - 4);
            }
        }
    };

    const [isLoading, setIsLoading] = useState(false)
    const [searchValue, setSearchValue] = useState("")
    const [localClearingAgent, setLocalClearingAgent] = useState<Record <string, any>>([])
    const getUser = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getUserByEmail",
            params: {
                Email: params.email
            }
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                const res = response.data.data.user
                setLocalClearingAgent(res)
            })
            .catch((error:any) => 
                {toast.error(error); setIsLoading(false)}
            );
    }

    const [isLoading2, setIsLoading2] = useState(false)
    const [users, setUsers] = useState<Record <string, any>>()
    const GetAllUsersForAThirdPartyRole = () => {
        setIsLoading2(true)
        var request: Record<string, any> = {
            what: "GetAllUsersForAThirdPartyRole",
            params: {
                page: currentPage,
                pageSize: 100,
                roleName: "LocalClearingAgent"
            }
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading2(false)
                const res = response.data.data
                setUsers(res)
            })
            .catch((error:any) => 
                toast.error(error.errorMessage)
            );

           
    } 

    const handleRadioChange = (event: any) => {
        const {checked, value} = event.target
        if(checked) setFormData({...formData, localClearingAgentId: value})
        else setFormData({...formData, localClearingAgentId: ""})
    }
    const row2 = users?.map((user: any, index: number) => {
        return (
                <tr key={index}>
                    <td className={localClearingAgent?.companyName === user?.user.companyName ? "grey-text" : ""}>
                        <input
                        disabled={localClearingAgent?.companyName === user?.user.companyName} 
                        type='radio' 
                        value={user?.user.id}
                        checked={formData.localClearingAgentId === user?.user.id}
                        onChange={handleRadioChange} />
                    </td>
                    <td>{ user?.user.companyName }</td>
                    <td>{ user?.user.email }</td>                    
                </tr>
        )
    })
    
    const [isSubmitting, setIsSubmitting] = useState(false)
    const HandleRessignShippingDocument = () => {
        var request: Record<string, any> = {
            what: "HandleRessignShippingDocument",
            data: {
                localClearingAgentId: formData.localClearingAgentId,
                transitManagerId: formData.transitManagerId,
                shippingDocumentId: formData.shippingDocumentId,
                reasonForReassignment: formData.reasonForReassignment,
            }
        };
        
        if(Object.values(formData).every(value => value)) {
            setIsSubmitting(true)
            makePatchRequest(request)
                .then((response: any) => {
                    setIsSubmitting(false)
                    toast.success(response.msg)
                    setReassignLocalClearingAgentModal(false) // close modal
                    clearFormData()
                    getShippingDocuments()
                })
                .catch((error:any) => {toast.error(error.errorMessage); setIsSubmitting(false)});
        }else {
            toast.warning("Kindly provide information for all required fields!")
        }
    }

    const row = shippingDocuments?.map((data: any, index:number) => {
        return (
            <tr key={index}>
                <td>{ currentPage === 1 ? currentPage + index : (((itemsPerPage*currentPage)-itemsPerPage)+1) + index }</td>
                <td>{ data.referenceNumber }</td>
                <td>{ data.shippingNumber }</td>
                <td>{ formatDateTime(data.createdDate) }</td>
                <td>{ data.consolidatedPackingList?.modeOfShipping }</td>
                <td>{ data?.consolidatedCommercialInvoice?.consignee }</td>
                <td>{ data?.consolidatedCommercialInvoice?.destinationPlant }</td>
               
                <td className="actions">
                    <div className="dropdown">
                        <button className="dropbtn-2"><span className="material-symbols-outlined" style={{fontSize: "24px"}}>more_horiz</span></button>
                        <div className="dropdown-content">
                            <button
                                onClick={() => {setReassignLocalClearingAgentModal(true); setFormData({...formData, shippingDocumentId: data.id, transitManagerId: user?.id}); GetAllUsersForAThirdPartyRole()}}
                                >Reassign Shipping Document</button>

                            <button
                            onClick={() => {navigate("/transitmanager/shippingdocuments/"+data.id); 
                            dispatch(setPageContext({page: "Local Clearing Agents", 
                                                url: `/transitmanager/assigned-shipping-documents/${localClearingAgent.email}`,
                                                }))}}
                            >View Details</button>
                        </div>
                    </div>
                </td>
            </tr>
        )
    })    
    const getShippingDocuments = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: "getShippingDocumentsForLocalClearingAgent",
            params: {
                Page: currentPage,
                PageSize: itemsPerPage,
                OrderBy: 2,
                LocalClearingAgentId: localClearingAgent.id
            }
        };
        if(searchValue) request.params.SearchString = searchValue
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data
                setShippingDocuments(res)
                setTotalItems(response.data.totalCount)
            })
            .catch((error:any) => 
                toast.error(error.errorMessage)
            );
    }

    const handleSearch = (event: any) => {
        const value = event.target.value
        if(!value) setSearchValue("")
    }

    useEffect(() => {
        getUser() // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if(localClearingAgent.id) getShippingDocuments()
        // eslint-disable-next-line
    }, [searchValue, currentPage, itemsPerPage, localClearingAgent.id, user])

    const page = "Local Clearing Agents"

    return (
        <Layout title={page}>
            <div className="container">
                <div className="main mt-2">
                    <div className="main-inner">                  
                        <div className="detail-top-section">
                            <div className="d-flex">
                                <Link to={"/transitmanager/localclearingagents"} className="actions">
                                    <p><span className="material-symbols-rounded">arrow_back</span> Back to Local Clearing Agents</p>
                                </Link>

                                <p style={{color: "#3e3e3e"}}><span className="material-symbols-rounded">account_circle</span>{ localClearingAgent?.firstName } { localClearingAgent?.lastName } - { localClearingAgent?.companyName }</p>
                            </div>  
                            <div className="tab">
                                <div className="tab-item active">
                                    <span className="material-symbols-rounded">assignment_add</span>
                                    <p>Assigned Shipping Documents</p>
                                </div>
                            </div>                      
                        </div>                        
                    </div>                    

                    <div className="main-inner mt-1">                 
                        <div className="main-inner-top">
                            <div className="d-flex">
                                <div className="search-container left-item">
                                    <span className="material-symbols-rounded">search</span>
                                    <input id="shippmentId" placeholder="Search Shipping Documents" onKeyUp={handleSearch} />
                                </div>
                                <button type="button" onClick={() => setSearchValue((document.getElementById("shippmentId") as HTMLInputElement)?.value)} className="custom-button orange left-item ml-2">Search</button>
                            </div>
                        </div> 
                        <div className='table-container custom' style={{minHeight: "calc(100vh - 160px)"}}>
                            <table>
                                <thead>
                                    <tr className="no-textwrap">
                                        <th>SN</th>
                                        <th>BL/AWB Number</th>
                                        <th>Shipment Number</th>
                                        <th>Created Date</th>
                                        <th>Shipping Mode</th>
                                        <th>Consignee</th>
                                        <th>Destination Plant</th>
                                        <th style={{width: "180px"}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? null : (
                                            shippingDocuments?.length === 0 ? <td className='no-records' colSpan={6}>No Records Found</td>
                                            : row
                                        )
                                    }
                                </tbody>
                            </table>
                            {isLoading ? <div className="loader">
                                        <img src={loading} alt="loading" />
                                        <p>Loading data...</p>
                                    </div> : null}
                        </div>
                        <div className="pagination-container">
                            <Pagination
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                totalPages={totalPages}
                                handlePrevious={handlePrevious}
                                handleNext={handleNext}
                                setCurrentPage={setCurrentPage}
                                getPageNumbers={getPageNumbers}
                                setItemsPerPage={setItemsPerPage}
                            startIndex={startIndex} />
                        </div>
                    </div>          
                </div>
            </div>

            <Modal isOpen={reassignLocalClearingAgentModal} style={customStyles} className="modal modal-8" ariaHideApp={false}>
                <div className="modal-header">
                    <h3>Reassign Shipping Document</h3>
                    <span className="material-symbols-rounded close"
                        onClick={() => {setReassignLocalClearingAgentModal(false); clearFormData()}}>close</span>
                </div>
                <label><span className="errorX mr-2">*</span>Select Local Clearing Agent</label>
                <div className="table-container custom modal-body mt-1" style={{minHeight: "200px", maxHeight: "300px", overflowY: "auto"}}>
                    <table>
                        <thead>
                            <tr className="no-textwrap">
                                <th></th>
                                <th>Company</th> 
                                <th>Official Email</th>                                         
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading2 ? null : (
                                        users?.length === 0 ? <td className='no-records' colSpan={6}>No Records Found</td>
                                        : row2
                                    )
                                }
                        </tbody>
                    </table>
                </div>
                <label><span className="errorX mr-2">*</span>Reason</label>
                <textarea
                    className="mt-1" 
                    onChange={(e) => setFormData({...formData, reasonForReassignment: e.target.value})}
                    value={formData?.reasonForReassignment}
                ></textarea>
                <small style={{fontSize: "10px"}} className={formData?.reasonForReassignment?.length >= 100 ? "mt-1 error" : "mt-1"}>{formData?.reasonForReassignment?.length}/100 Characters</small> 

                <div className="modal-footer bt-1">
                    <button className="custom-button grey-outline"
                        onClick={() => setReassignLocalClearingAgentModal(false)}>Cancel</button>
                    <button disabled={isSubmitting} type="submit" className="custom-button orange"
                        onClick={() => HandleRessignShippingDocument()}>{isSubmitting ? "Reassigning..." : "Reassign"}</button>
                </div>
            </Modal> 
            <ToastContainer />
        </Layout>
    )
}

export default AssignedShippingDocuments